import { Icon, IconProps } from "@chakra-ui/react";

export default function Recurring(props: IconProps) {
  return (
    <Icon viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M1 4.5L2.5 3L4 4.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 9H3.5C3.23478 9 2.98043 8.89464 2.79289 8.70711C2.60536 8.51957 2.5 8.26522 2.5 8V3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 7.5L9.5 9L8 7.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 3H8.5C8.76522 3 9.01957 3.10536 9.20711 3.29289C9.39464 3.48043 9.5 3.73478 9.5 4V9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
